<template>
    <div>
        <md-card>
            <md-card-header class="header-grid">
                <div class="md-layout">
                    <div class="md-layout-item">
                        <div class="md-subheading">
                            {{ ClientName }}
                        </div>
                        <div class="md-subhead" v-if="client.exact_client_number">
                            Exact nummer: {{ client.exact_client_number }}
                        </div>
                    </div>
                    <div class="md-layout-item" style="text-align-last: right">
                        <md-button
                            @click="showDialogEditClientFunction()"
                            class="md-icon-button md-mini"
                            v-if="this.client.client_id"
                        >
                            <md-icon>edit</md-icon>
                        </md-button>
                    </div>
                </div>
            </md-card-header>

            <md-card-content v-if="deliveryAddress">
                <div class="md-layout-item md-small-size-75 md-caption grid-item">
                    <div>{{ address.address }}</div>
                    <div>
                        {{ address.zip_code }}
                        {{ address.city }}
                    </div>
                    <div v-if="client.client_data.email">
                        {{ client.client_data.email ? client.client_data.email : undefined }}
                    </div>
                    <div v-if="client.client_data.telephone_phone">
                        {{ client.client_data?.telephone_phone ? client.client_data?.telephone_phone : undefined }}
                    </div>
                    <div v-if="client.client_data.mobile_phone">
                        {{ client.client_data?.mobile_phone ? client.client_data?.mobile_phone : undefined }}
                    </div>
                    <div v-if="client.client_data?.company_data">
                        {{
                            client.client_data?.company_data?.bank_account
                                ? client.client_data?.company_data?.bank_account
                                : undefined
                        }}
                    </div>
                </div>
            </md-card-content>
        </md-card>
        <md-dialog style="z-index: 9" :md-active.sync="showDialogEditClient">
            <md-dialog-title>Wijzig klant gegevens </md-dialog-title>

            <md-dialog-content>
                <div v-if="form">
                    <form novalidate @submit.prevent="validateForm">
                        <div class="md-layout">
                            <div class="md-layout-item md-medium-size-50 md-small-size-100">
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('first_name')">
                                        <label for="first_name">Voornaam</label>
                                        <md-input
                                            required
                                            name="first_name"
                                            id="first_name"
                                            v-model="form.first_name"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.form.first_name.minLength"
                                            >Naam is te kort</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('last_name')">
                                        <label for="last_name">Achternaam</label>
                                        <md-input
                                            required
                                            name="last_name"
                                            id="last_name"
                                            v-model="form.last_name"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.form.last_name.minLength"
                                            >Naam is te kort</span
                                        >
                                    </md-field>
                                </div>

                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('phone')">
                                        <label for="phone">Tel.nr</label>
                                        <md-input
                                            name="phone"
                                            id="phone"
                                            v-model="form.telephone_phone"
                                            :disabled="sending"
                                        />
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('phone')">
                                        <label for="mobile_phone">GSM.nr</label>
                                        <md-input
                                            name="mobile_phone"
                                            id="mobile_phone"
                                            v-model="form.mobile_phone"
                                            :disabled="sending"
                                        />
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('email')">
                                        <label for="email">Email</label>
                                        <md-input
                                            required
                                            name="email"
                                            id="email"
                                            v-model="form.email"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.form.email.email"
                                            >Geen correct email adres!</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('email')">
                                        <label for="Bank_account">BE nr</label>
                                        <md-input
                                            required
                                            name="email"
                                            id="email"
                                            v-model="form.company_data.bank_account"
                                            :disabled="sending"
                                        />
                                    </md-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelEditClient()" class="md-primary">Cancel</md-button>
                <md-button @click="saveEditClient()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ClientApi, IAddress, IClientDataEntity, IClientEntity } from '@phrospr/api-backend';
import { PlanningItemEngine } from '@phrospr/lib-core/src/engine/planning-item.engine';
import { IVuelidateComponentOptions } from '@/services/entities/vuelidate.entity';
import { email, minLength, required } from 'vuelidate/lib/validators';
import updateClient = ClientApi.updateClient;
import { quoteStore } from '@/store/quote/quote.store';

@Component({
    validations: {
        form: {
            first_name: { minLength: minLength(2) },
            last_name: { minLength: minLength(2) },
            email: { email },
            mobile_phone: {},
            telephone_phone: {},
            phone: {},
            company_data: {
                company_name: {},
            },
        },
    },
} as IVuelidateComponentOptions)
export default class ClientCard extends Vue {
    @Prop() client: IClientEntity;
    @Prop() deliveryAddress: IAddress | null;

    PlanningItemEngine = PlanningItemEngine;
    showDialogEditClient = false;
    invalidForm = false;
    $v: any;
    sending = false;
    form: IClientDataEntity;

    get ClientName() {
        return PlanningItemEngine.getClientDataName(this.client.client_data);
    }

    get address() {
        return (
            this.deliveryAddress ?? {
                address: '/',
                city: '/',
                zip_code: '/',
            }
        );
    }

    constructor() {
        super();
        this.setForm();
    }

    get selectedClient() {
        return quoteStore.state.selectedClient;
    }

    public async cancelEditClient() {
        this.showDialogEditClient = false;
    }

    setForm() {
        this.form = this.client.client_data;
    }
    async showDialogEditClientFunction() {
        this.setForm();
        this.showDialogEditClient = true;
    }

    public async saveEditClient() {
        this.validateForm();
        this.client.client_data.first_name = this.form.first_name;
        this.client.client_data.last_name = this.form.last_name;
        this.client.client_data.email = this.form.email;
        this.client.client_data.telephone_phone = this.form.telephone_phone;
        this.client.client_data.mobile_phone = this.form.mobile_phone;
        this.client.client_data.company_data.bank_account = this.form.company_data.bank_account;
        await ClientApi.updateClient(this.client);
        this.showDialogEditClient = false;
    }

    validateForm() {
        this.invalidForm = false;
        this.$v.$touch();
        if (!this.$v.$invalid) {
        } else this.invalidForm = true;
    }

    getValidationClass(fieldName) {
        const keys = fieldName.split('.');
        let field = this.$v.form[keys[0]];
        for (let i = 1; i < keys.length; i++) field = field[keys[i]];
        if (field) {
            return {
                'md-invalid': field.$invalid && field.$dirty,
            };
        }
    }
}
</script>

<style lang="scss" scoped></style>
